import React , { useState,useEffect }from 'react'
import { Button,  Form, Input,message, Tree,Modal,Select,Radio,Space } from 'antd';
// import Icon,{EditOutlined  } from '@ant-design/icons';
// import './index.css';
import {api_user_add, api_user_edit} from '../../../api';
import CryptoJS from 'crypto-js';
import { localStorageGet } from '../../../utils/global.js';

// const navigate = useNavigate();
  // navigate(-1)//适用于返回上级页面
  // navigate('/router');//也可直接加路径

// const { Header, Content, Footer, Sider } = Layout;
// const { TextArea } = Input;
// const { Option } = Select;
const screenHeight = document.body.clientHeight;

const App =(props)=>{
    const {showModal, closeModal, rowInfo, refreshlist, treeMenus, tenantList, roleList} = props;
    console.log('1111111111111111111111111111111111111-', rowInfo, tenantList)
    const [form] = Form.useForm();
    const [bEdit,setBEdit] = useState(true);
    const [loading,setLoading] = useState(false);
    const [checkedKeys, setCheckedKeys] = useState([]);
    const [tenantid, setTenantid] = useState("");

    const currentUserinfo = localStorageGet('UserInfo_k');

    useEffect(() => {
      if(showModal){
        if(rowInfo.id == undefined){
          if(currentUserinfo.roleid!='99' && tenantList.length>1){
            setTenantid(tenantList[1].value);
          }
          form.resetFields();
          setCheckedKeys([]);
        } else {
          for (let key in rowInfo) {
            form.setFieldValue(key, rowInfo[key])
          }
          setCheckedKeys(JSON.parse(rowInfo.authority));
        }
      }else{
        form.resetFields();
        setLoading(false);
        setCheckedKeys([]);
        setTenantid("");
      }
    }, [showModal]);

    const onCheck = (checkedKeysValue) => {
      console.log('onCheck', checkedKeysValue);
      setCheckedKeys(checkedKeysValue);
      // 将选中的 keys 同步到表单中
      form.setFieldValue("authority", checkedKeysValue);
    };
    
    const onFinish = async(value)=>{
      console.log(value);
      // if(!value.username){
      //   message.warn("请输入邮箱接口");
      //   return false;
      // }
      setLoading(true);

      value.userid = rowInfo.id;
      var fun = rowInfo.id ? api_user_edit : api_user_add;

      try {
        if(value.password)
          // value.password = encrypt(value.password);
          value.password = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse("h10"+value.password+"i01"));
        console.log(value);
        await fun(value).then((res) => {
          setLoading(false);
          console.log(fun+'-res-----------------', res);
          if (res.data.code == 9) {
            message.success("操作成功");
            closeModal();
            refreshlist();
          }else
            message.error(res.data.msg);
        });
        } catch (error) {
          console.log(error)
          message.error("其他异常");
          setLoading(false);
          return false;
        }
  }

  return (
    <Modal 
        key="userinfo"
        title={rowInfo.tenant_id ? '编辑' :'新增'+'用户'}
        open={showModal}
        width={600}
        bodyStyle={{maxHeight:screenHeight*0.8,overflowY:"scroll"}}
        centered
        destroyOnClose={true}
        maskClosable={false}
        footer={[<Button  className="m-btn-white" onClick={closeModal}>
        取消
        </Button>,
        <Button type="primary" loading={loading} style={{ marginLeft:'20px',backgroundColor:"rgb(24,188,156)"}} onClick={()=>{form.submit()}}>
        确认
        </Button>] }
        onCancel={closeModal}>
          <Form form={form}
            className='loginForm reginfo'
            name="normal_login"
            // labelCol={{span: 5}}
            // wrapperCol={{span: 16}}
            onFinish={onFinish}
            layout="horizontal"
            // onFinishFailed={this.onFinishFailed}
            autoComplete="off"
            labelAlign="left"
            labelCol={{span:5}}
            // style={{fontSize:12}}
            size="small"
            initialValues={{
              is_outlook_enabled:"0",
              status:'1',
              tenant_id: tenantid,
              roleid:'',
            }}
        >
            {/* <Form.Item
                label="用户名称"
                name="username"
                rules={[
                  {required: true, message: '请输入用户名称',},
                ]}
            >
            <Input disabled={rowInfo.id?true:false} />
            </Form.Item> */}
            <Form.Item
                label="用户邮箱"
                name="email"
                rules={[
                  {required: true, message: '请输入用户邮箱',},
                  {
                    type: 'email',
                    message: '请输入有效的邮箱地址',
                  },
                ]}
            >
            <Input />
            </Form.Item>
            <Form.Item
                label="用户手机"
                name="phone"
                rules={[
                  {required: true, message: '请输入用户手机',},
                  {
                    pattern: /^1[3-9]\d{9}$/,
                    message: '请输入有效的手机号码',
                  },
                ]}
            >
            <Input />
            </Form.Item>
            <Form.Item
                label="用户密码"
                name="password"
                rules={rowInfo.id?[]:[
                  {required: true,message: '密码必须6-30个字符',},
                  {max: 30,message: '密码最多30位',},
                  {min: 6,message: '密码至少6位',},
                ]}
            >
            <Input.Password placeholder={rowInfo.id?'空则不修改':''} />
            </Form.Item>
            <Form.Item
                label="所属租户"
                name="tenant_id"
                rules={[
                  {required: true, message: '请选择所属租户',},
                ]}
            >
              <Select
                  // placeholder="请选择选择栏目"
                  // onChange={onProdChange}
                  options={tenantList}
                  disabled={rowInfo.id||currentUserinfo.roleid!='99'?true:false}
              >
                  {/* <Option value="1731">51Job</Option>
                  <Option value="1736">58同城</Option> */}
              </Select>
            </Form.Item>
            <Form.Item
                label="用户角色"
                name="roleid"
                rules={[
                  {required: true, message: '请选择用户角色',},
                ]}
            >
              <Select
                  // placeholder="请选择选择栏目"
                  // onChange={onProdChange}
                  // defaultValue={""}
                  // allowClear
                  // style={{width:"50%"}}
                  // disabled={true}
                  options={roleList}
                  // disabled={rowInfo.id?true:false}
              >
                  {/* <Option value="1731">51Job</Option>
                  <Option value="1736">58同城</Option> */}
              </Select>
            </Form.Item>
            <Form.Item
              name="authority"
              label="配置页面"
              // validateStatus="success"
              rules={[
                {required: true, message: '请选择配置页面',},
              ]}
            >
              <Tree
                checkable
                height={250}
                onCheck={onCheck}
                checkedKeys={checkedKeys}
                treeData={treeMenus}
              />
            </Form.Item>
            <Form.Item
                label="用户状态"
                name="status"
            >
              <Radio.Group style={{width:"80%"}}  >
                <Space size={10}>
                <Radio value={"1"}>激活</Radio>
                <Radio value={"0"}>停用</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>

        </Form>
        </Modal>
  )
}
export default App
